/**
 * Created by Mark on 24/04/2017.
 */


import React from "react";
import {Button, Modal} from 'react-bootstrap'
import AssignmentServices from '../../../../services/assignments-service';
import Table from '../../../../components/general_table.js';
import StringTask from '../../../../components/TaskNamesList';
import Translation from '../../../../store/internationalization-store';
import StudentGradeContent from '../../../popup/grading_popup.js';
import AnswerReport from '../../../answer-report.js';
import AssignmentStore from '../../../../store/assignment-store.js';
import Constants from '../../../../constants.js';

let colRanges = [
    {thresholdLower:70 , thresholdHigher:100 , total:0 , color:"#88c057"},
    {thresholdLower:40 , thresholdHigher:70  , total:0 , color:"#ffcc66"},
    {thresholdLower:1 , thresholdHigher:40   ,  total:0 , color:"#ed7161"},
    {thresholdLower:0 , thresholdHigher:0   ,  total:0 , color:"#ffffff"}
];

class HomeworkScoresPanel extends React.Component {

    constructor(props) {
        super();

        this.props = props;
        this.initalComment = false;
        this.feedback = {};
        this.slice = 0;
        this.state = {
            stuff:false,
            gradeModalShow:false
        }
    }

    componentDidMount(){
        
    }



    componentWillMount(){
        AssignmentStore.on(Constants.GET_GRADABLE_QUESTIONS , ()=> {
            var gradable = AssignmentStore.getGradableQuestions();
            var actualGradable = [];
            for (var i = 0;gradable != undefined && i < gradable.length; i++) {
                var currentGradable = gradable[i];
                var madeGradable = [];
                madeGradable.id = i;
                madeGradable.uid = i;
                madeGradable.user_uid = currentGradable.user_uid
                madeGradable.name = currentGradable.nickname;
                madeGradable.section = currentGradable.title
                madeGradable.skill = currentGradable.skill_group
                madeGradable.date = currentGradable.last_updated
                madeGradable.grade = currentGradable.percentage
                if (currentGradable.is_homework != false) {
                    madeGradable.ishomework = "✅";
                } else {
                    madeGradable.ishomework = "";
                }
                madeGradable.rawData = currentGradable
                actualGradable.push(madeGradable);
                if (this.state.tab == "awaiting") {
                    this.setState({tab:"graded"});
                    this.setState({tab:"awaiting"});
                }
            }
            this.setState({loaded:true, gradable:actualGradable})
        })

       this.getScores();
    }

    getScores(){
        AssignmentServices.getScores(this.props.data.homeworkID).then(function(response){
            this.feedback.value = "";

            let hasWritting = false;
            var table = response.table;
            var newHeaders = [];

            for(var idx = 0 ; idx < table.length; idx++ )
            {
                var total = 0 ;
                var number = 0;
                for(var jdx = 0 ; jdx < response.headers.length; jdx++)
                {

                    var module = response.headers[jdx];
                    var titleString = new StringTask({tasks:[{
                        translation:module.translation,
                        type:module.type,
                        verb_name:module.verb_name,
                        skill:module.skill,
                        title:module.title,
                        module_translations: module.module_translations || []
                    }]}).returnString();

                    table[idx][response.headers[jdx].name]['question-name'] = titleString
                    table[idx][response.headers[jdx].name+"-percentage"] = table[idx][response.headers[jdx].name]['percentage'];
                    if(table[idx][response.headers[jdx].name]['percentage'])
                    {
                        
                        var newNumber = Number(table[idx][response.headers[jdx].name]['percentage'].replace(/[^0-9\-]/g, ''));
                        if (newNumber != -1) {
                            number++;
                            total += newNumber;
                        }
                        
                        if(table[idx][response.headers[jdx].name]['key'].game_uid == 206)
                        {
                            hasWritting = true
                        }
                    }

                }

                table[idx]['average'] = isNaN(total) || total == 0 || number == 0 ? "-%" : String(Math.ceil(total/number)) + "%"
            }


            var test = function(value , thresholdLower , thresholdHigher){

                value = String(value.percentage).replace('%' , '');

                if(value == 0 && thresholdLower == 0)
                {
                    return true;
                }

                return value > Number(thresholdLower) && value <= Number(thresholdHigher)
            };

            for(var jdx = 0; jdx < response.headers.length; jdx++) {
                var module = response.headers[jdx];
                var titleString = new StringTask({tasks:[{
                    translation:module.translation,
                    type:module.type,
                    verb_name:module.verb_name,
                    skill:module.skill,
                    title:module.title,
                    module_translations: module.module_translations || []
                }]}).returnString();




                let col = null;

                for(var r = 0 ; r < colRanges.length; r++)
                {
                    console.log()
                    if(test( response.headers[jdx].name+"-percentage" , colRanges[r].thresholdLower , colRanges[r].thresholdHigher))
                    {
                        col = colRanges[r].color
                        break;
                    }
                }

                console.log(col)



                newHeaders.push({
                    dataField: response.headers[jdx].name,
                    text: titleString,
                    headerFormatter:(text)=>{
                        let parts =  String(text.text).split('|');
                        let html = [];

                        for(var i = 0 ; i < parts.length; i++)
                        {
                            html.push(parts[i])
                            html.push(<br/>)
                        }

                        return html
                    },
                    headerClasses:"header-class",
                    headerAlign: 'center',
                    align: 'center',
                    style: (one , two , three)=>{

                        let col = null;

                        for(var r = 0 ; r < colRanges.length; r++)
                        {
                            if(test( one , colRanges[r].thresholdLower , colRanges[r].thresholdHigher))
                            {
                                col = colRanges[r].color
                                break;
                            }
                        }

                        return {
                            fontWeight: 'bold',
                            width: '17.5%',
                            background:col
                        }
                    },
                    formatter: this.renderPercentageData.bind(this , response.headers[jdx].name)
                })
            }



            this.setState({
                showComment:false , showDetail: false , studentDetail:{},
                "data":table , hasWritting:hasWritting, newHeaders:newHeaders});
        }.bind(this));
    }

    renderPercentageData(key , cell, row){



        if (cell.percentage == "GRADE%") {

            return <Button onClick={function(row) {

                AssignmentServices.getGradableQuestionsIndividual(
                    row.key.homeworkID, row.key.feature_uid, row.key.game_uid,
                    row.key.user_uid, row.key.type, row.key.rel_module_uid,
                    row.key.score_uid).then(function(response) {
                        try {
                            response.gradableActions[0].rawData = response.gradableActions[0];
                        } catch(e) {

                        }
                        this.setState({question :response.gradableActions,gradeModalShow:true});
                    }.bind(this));
            }.bind(this , row[key])} size="sm" >{Translation.get(12211 , 'Grade')}</Button>


        } else if(['206' , '207' , '208'].indexOf(row[key].key.game_uid) > -1 && cell.percentage != "-1%") {
            return <b className="hyperlink hyperlink_black" onClick={function(row) {
                AssignmentServices.getGradableQuestionsIndividual(
                    row.key.homeworkID, row.key.feature_uid, row.key.game_uid,
                    row.key.user_uid, row.key.type, row.key.rel_module_uid,
                    row.key.score_uid).then(function(response) {
                    try
                    {
                        response.gradableActions[0].rawData = response.gradableActions[0];
                    }
                    catch(e)
                    {

                    }

                    this.setState({question :response.gradableActions,gradeModalShow:true});
                }.bind(this));
            }.bind(this , row[key])} size="sm" >{cell.percentage}</b>
        } else if (cell.percentage != "-1%"){
            if (cell.key.feature_uid == "1") {
                return <b>{cell.percentage}</b>
            }
            return <b className="hyperlink hyperlink_black" onClick={function(row) {
                    AssignmentServices.scoreSummary(row.key).then(function(response){
                        this.userData = response.data;
                        this.reportType = response.type;
                        this.reportLanguage = response.language;
                        this.reportGameUID= response.game;
                        this.setState({openDialog:true});
                    }.bind(this));
                }.bind(this , row[key])} size="sm" >{cell.percentage}</b>
        }  else {
            return "-";
        }
    }

    close(){
        this.setState({openDialog:false});
    }


    render(){
        if (this.state.data == undefined) {
            return ""
        }

        var cols = [{
            dataField: 'student_name',
            text: Translation.get(827,'Student Name'),
            sort: true,
            headerStyle: {
                width: '20%'
            },
            style: {
                fontWeight: 'bold',
                width: '20%'
            }
        },{
            dataField: 'average',
            text: Translation.get(693,'Average Score'),
            headerAlign: 'center',
            align: 'center',
            headerStyle: {
                width: '10%'
            },
            style: (one , two , three)=>{

                let col = null;

                var test = function(value , thresholdLower , thresholdHigher){

                    value = String(value).replace('%' , '');

                    if(value == 0 && thresholdLower == 0)
                    {
                        return true;
                    }

                    return value > Number(thresholdLower) && value <= Number(thresholdHigher)
                };
                
                for(var r = 0 ; r < colRanges.length; r++)
                {
                    if(test( one , colRanges[r].thresholdLower , colRanges[r].thresholdHigher))
                    {
                        col = colRanges[r].color
                        break;
                    }
                }

                return {
                    fontWeight: 'bold',
                    width: '10%',
                    background:col
                }
            },
        }];

        cols = cols.concat(this.state.newHeaders);

        let gradeModalClose = () => {
            this.setState({ gradeModalShow: false });
        }

        let onSave = () => {
            this.getScores();
            this.setState({ gradeModalShow: false , loaded:false});
        }

        return <div style={{paddingTop:"10px"}} className="pmbb-body">
            <Modal show={this.state.openDialog} onHide={this.close.bind(this)} size="lg">
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <AnswerReport show={this.state.openDialog} gameUID={this.reportGameUID} language={this.reportLanguage} data={this.userData || {}} type={this.reportType || ""} />
                </Modal.Body>
            </Modal>
            <StudentGradeContent onSave={onSave} studentName="This is a student name" show={this.state.gradeModalShow} data={this.state.question} uid={0} onHide={gradeModalClose} />
            <Table pageSize={50} columns={cols} data={this.state.data} maxColumnLimit={6} startColumn={2}/>
        </div>;
    }
}




export default {
    name: function() {return <span>{Translation.get(12256,'Results and grading')}</span>},
    component: HomeworkScoresPanel
}